function initializeCommunicationsWorkspace(): void {
  const dialog = document.querySelector<HTMLDialogElement>('[data-campaign-dialog]');
  if (!dialog) return;

  document.querySelectorAll<HTMLElement>('[data-open-campaign]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    });
  });

  document.querySelectorAll<HTMLElement>('[data-close-campaign]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  if (dialog.dataset.autoOpen === 'true' && !dialog.open) dialog.showModal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCommunicationsWorkspace, { once: true });
} else {
  initializeCommunicationsWorkspace();
}
